import { cva, type VariantProps } from "class-variance-authority";
import type { ReactNode } from "react";

import { cn } from "@/lib/cn";

/** One status -> tokens map, applied everywhere (ui-patterns skill). */
const badge = cva(
  "inline-flex items-center gap-1 rounded-xs px-2 py-0.5 text-2xs font-medium whitespace-nowrap",
  {
    variants: {
      tone: {
        neutral: "bg-surface-sunken text-ink-muted",
        success: "bg-success-soft text-success-soft-ink",
        warning: "bg-warning-soft text-warning-soft-ink",
        danger: "bg-danger-soft text-danger-soft-ink",
        accent: "bg-accent-soft text-accent-soft-ink",
        info: "bg-info-soft text-info-soft-ink",
      },
    },
    defaultVariants: { tone: "neutral" },
  },
);

export function Badge({
  tone,
  children,
  className,
}: VariantProps<typeof badge> & {
  children: ReactNode;
  className?: string | undefined;
}) {
  return <span className={cn(badge({ tone }), className)}>{children}</span>;
}
